import axios from 'axios';
const httpUploader = (() => {
  function SingletonClass() {
    let url = '';
    if (typeof process.env.REACT_APP_API_LINK == 'undefined') {
      if (
        window.location.origin.includes('http://localhost') ||
        window.location.origin.includes('http://127.0.0.1')
      ) {
        url = 'http://localhost:5000/api/';
      } else {
        url = `${window.location.origin}/api/`;
      }
    } else {
      url = process.env.REACT_APP_API_LINK;
    }

    const instance = axios.create({
      baseURL: url,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': `multipart/form-data`,
      },
    });
    if (localStorage.getItem('access_token')) {
      instance.defaults.headers.common[
        'Authorization'
      ] = `Bearer ${localStorage.getItem('access_token')}`;
    }

    instance.interceptors.request.use(
      function (config) {
        const access_token = localStorage.getItem('access_token');
        if (config.url !== 'savvy/users/login') {
          config.headers['Authorization'] = `Bearer ${access_token}`;
        }
        return config;
      },
      function (error) {
        // Do something with request error
        return Promise.reject(error);
      }
    );
    return instance;
  }

  var instance;

  return {
    getInstance: function () {
      if (!instance) {
        instance = new SingletonClass();
        delete instance.constructor;
      }
      return instance;
    },
  };
})();

export default httpUploader.getInstance();
